var $ = require('jquery');
'use strict';

$( document ).ready(function() {
	// Make carousel behave better
	$('.ult-carousel-wrapper .ult-item-wrap .ult-item-wrap').contents().unwrap();

	// Tab index to terms button
	$('.vc-terms__button').attr('tabindex', '0');

	// theme button inner to multibuttons
	$('.vcex-multi-buttons .c-button').wrapInner('<span class="theme-button-inner"></span>');

	// IS pages update home link
	if ($('body').hasClass('body--icelandic')) {
		$('#site-logo-link').attr('href', '/is/');
	}
	if ($('body').hasClass('body--fr')) {
		$('#site-logo-link').attr('href', '/fr/');
	}
	if ($('body').hasClass('body--de')) {
		$('#site-logo-link').attr('href', '/de/');
	}
	if ($('body').hasClass('body--es')) {
		$('#site-logo-link').attr('href', '/es/');
	}
	if ($('body').hasClass('body--pt')) {
		$('#site-logo-link').attr('href', '/pt/');
	}
	if ($('body').hasClass('body--zh-hans')) {
		$('#site-logo-link').attr('href', '/zh-hans/');
	}
	if ($('body').hasClass('body--zh-hant')) {
		$('#site-logo-link').attr('href', '/zh-hant/');
	}
	if ($('body').hasClass('body--ja')) {
		$('#site-logo-link').attr('href', '/ja/');
	}
	if ($('body').hasClass('body--ko')) {
		$('#site-logo-link').attr('href', '/ko/');
	}});


// Lazy load video
const lazyLoadVideo = document.querySelector('video.lazy');
if (lazyLoadVideo) {
	document.addEventListener('DOMContentLoaded', function() {
		var lazyVideos = [].slice.call(document.querySelectorAll('video.lazy'));

		if ('IntersectionObserver' in window) {
			var lazyVideoObserver = new IntersectionObserver(function(entries) {
				entries.forEach(function(video) {
					if (video.isIntersecting) {
						for (var source in video.target.children) {
							var videoSource = video.target.children[source];
							if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
								videoSource.src = videoSource.dataset.src;
							}
						}

						video.target.load();
						video.target.classList.remove('lazy');
						lazyVideoObserver.unobserve(video.target);
					}
				});
			});

			lazyVideos.forEach(function(lazyVideo) {
				lazyVideoObserver.observe(lazyVideo);
			});
		}
	});

}
